import {ViewHook} from 'phoenix_live_view';

export class GameCountdown extends ViewHook {
  private frame=0;
  mounted() {
    const remaining=Number(this.el.dataset.startAt)-Number(this.el.dataset.serverNow);
    const deadline=performance.now()+remaining;
    const number=this.el.querySelector<HTMLElement>('[data-countdown-number]');
    let previous='';
    const tick=()=>{
      const value=Math.ceil((deadline-performance.now())/1000);
      const text=value>0?String(value):'GO';
      if(number&&text!==previous){number.textContent=text;previous=text;}
      if(value>0)this.frame=requestAnimationFrame(tick);
    };
    tick();
  }
  destroyed(){cancelAnimationFrame(this.frame);}
}
